/**
 * Resources / Blog card filtering (port of WP assets/js/resources.js, no WP AJAX).
 * Tabs: .resource-tab[data-filter]   Search: #resource-search   Audience: #audience-filter
 * Cards: .resource-card[data-type][data-title][data-audience]
 */
(function () {
  'use strict';

  var state = { filter: 'all', search: '', audience: 'all' };

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function apply() {
    var cards = document.querySelectorAll('.resource-card');
    var grid = document.getElementById('resources-grid');
    var empty = document.getElementById('no-results');
    var visible = 0;

    cards.forEach(function (card) {
      var type = card.getAttribute('data-type') || '';
      var audience = card.getAttribute('data-audience') || '';
      var title = card.getAttribute('data-title') || '';
      var ok = (state.filter === 'all' || type === state.filter) &&
        (state.audience === 'all' || audience.indexOf(state.audience) !== -1) &&
        (!state.search || title.indexOf(state.search) !== -1);
      card.style.display = ok ? '' : 'none';
      if (ok) {
        visible++;
        card.classList.add('animate-in');
      }
    });
    setTimeout(function () {
      cards.forEach(function (c) { c.classList.remove('animate-in'); });
    }, 300);

    if (empty) empty.style.display = visible === 0 ? 'block' : 'none';
    if (grid) grid.style.display = visible === 0 ? 'none' : '';
  }

  function init() {
    var active = document.querySelector('.resource-tab.active');
    if (active) state.filter = active.getAttribute('data-filter') || 'all';
    apply();
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('.resource-tab') : null;
    if (!tab) return;
    e.preventDefault();
    document.querySelectorAll('.resource-tab').forEach(function (t) { t.classList.remove('active'); });
    tab.classList.add('active');
    state.filter = tab.getAttribute('data-filter') || 'all';
    apply();
  });

  document.addEventListener('input', debounce(function (e) {
    if (!e.target || e.target.id !== 'resource-search') return;
    state.search = e.target.value.toLowerCase().trim();
    apply();
  }, 300));

  document.addEventListener('keydown', function (e) {
    if (e.target && e.target.id === 'resource-search' && e.key === 'Enter') {
      e.preventDefault();
      state.search = e.target.value.toLowerCase().trim();
      apply();
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.resources-search-btn') : null;
    if (!btn) return;
    var input = document.getElementById('resource-search');
    if (input) {
      state.search = input.value.toLowerCase().trim();
      apply();
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'audience-filter') return;
    state.audience = e.target.value;
    apply();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
